import axios from 'axios';

export default {

    //Permet de récuperer la liste des concours
    get() {
        return axios.get(process.env.VUE_APP_API_URI + '/api/concours');
    },

    //Permet de récuperer les informations d'accueil sur le concours sélectionné
    getHome(userId, concoursId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/concours/' + concoursId + '/' + userId + '/home');
    },

    //Permet de récuperer le résumé d'un concours
    getResume(userId, concoursId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/concours/' + userId + '/resume/' + concoursId);
    },

    //Permet de récuperer les résultats au concours d'un utilisateur
    getResult(userId, concoursId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/concours/' + userId + '/result/' + concoursId);
    },

    //Permet de récuperer le classement des utilisateurs sur un concours
    getClassement(userId, concoursId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/concours/' + userId + '/result/' + concoursId + '/classement');
    },

    //Permet de récuperer la destination du concours
    getDestination(concoursId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/destination/' + concoursId + '/data');
    },

    //Permet de récuperer la liste des excursions du concours
    getExcursionList(concoursId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/excursions/' + concoursId + '/list');
    },

    //Permet de récuperer les données d'une excursion
    getExcursionData(concoursId, excursionId) {
        return axios.get(process.env.VUE_APP_API_URI + '/api/excursion/' + concoursId + '/data/' + excursionId);
    },

    //Permet de récuperer le classement des utilisateurs sur une excursion
    getExcursionRanking(userId, concoursId, excursionId, all = false) {
        //Si all est à true alors en renvoie tous les utilisateurs et pas seulement ceux rattaché à l'utilisateur courrant
        let params = "?all=" + all;
        return axios.get(process.env.VUE_APP_API_URI + '/api/excursion/' + concoursId + '/data/' + excursionId + '/classement/' + userId + params);
    }

}
